export const remCalc = (px: number, base = 16) => {
  return `${(1 / base) * px}rem`;
};
